import React from 'react';

export class UserAvatar extends React.Component {
   render() {
      return <div className='neo-icon-contact-filled'></div>;
   }
};
